/**
 * @returns {(value: string) => boolean}
 */
export default function isApplicationName() {
  return (value: string) => {
    return /^[a-z0-9]+([\w-]{0,61}[a-z0-9])?$/.test(value) && !/--/.test(value);
  };
}
